import { render, staticRenderFns } from "./HawkeyePrelabQuiz2.vue?vue&type=template&id=18a1d051&scoped=true&"
import script from "./HawkeyePrelabQuiz2.vue?vue&type=script&lang=js&"
export * from "./HawkeyePrelabQuiz2.vue?vue&type=script&lang=js&"
import style0 from "./HawkeyePrelabQuiz2.vue?vue&type=style&index=0&id=18a1d051&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1d051",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup,VSelect})
